import * as BaseAPI from '@/api/baseAPI';
import State from "../../../shared/models/state";

export async function getStates(): Promise<State[]> {
  const result = await BaseAPI.simpleGet(`/states`);
  return result.data;
}